"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANDING_TYPE = void 0;
exports.LANDING_TYPE = {
    LANDING: 'LANDING',
    QUIZ: 'QUIZ',
    SHOP: 'SHOP',
    SUBLANDER: 'SUBLANDER'
};
//# sourceMappingURL=landingType.js.map